import { render, staticRenderFns } from "./from.vue?vue&type=template&id=210561a7&scoped=true"
import script from "./from.vue?vue&type=script&lang=js"
export * from "./from.vue?vue&type=script&lang=js"
import style0 from "./from.vue?vue&type=style&index=0&id=210561a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210561a7",
  null
  
)

export default component.exports